// @flow
import {closestIndex} from './closestIndex';

type Params = {|
    offset: number,
    offsetWidth: Array<number>,
    viewportWidth: number,
|};

export const PRE_SCAN_CELL_RATIO = 0.2; // 20% of the table viewport width
const DEFAULT_START_CELL_INDEX = 0;
const CELL_INDEX_OFFSET = 1;

export const getCellStartIndex = ({offset, offsetWidth, viewportWidth}: Params): number => {
    const index = closestIndex(offset - viewportWidth * PRE_SCAN_CELL_RATIO, offsetWidth);
    if (index > DEFAULT_START_CELL_INDEX) {
        return index - CELL_INDEX_OFFSET;
    }
    return DEFAULT_START_CELL_INDEX;
};
